if (!customElements.get('product-bundle')) {
    class ProductBundle extends HTMLElement {
        constructor() {
            super();
            this.sectionId = this.dataset.sectionId;
            this.productId = this.dataset.productId;
            this.bundleSource = this.dataset.bundleSource;
            this.maxProducts = parseInt(this.dataset.maxProducts) || 3;
            this.includeCurrentProduct = this.dataset.includeCurrent === 'true';
            this.recommendationUrl = this.dataset.recommendationUrl;

            this.productsContainer = this.querySelector(`#bundle-products-${this.sectionId}`);
            this.totalPriceElement = this.querySelector('.product-bundle__total-price');
            this.addToCartButton = this.querySelector('[data-add-to-cart]');

            this.init();
        }

        init() {
            this.setupEventListeners();
            this.updateTotal();
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                if (event.source !== 'bundle-selector') return;
                this.showSuccessFeedback();
            });
        }

        setupEventListeners() {
            // Checkbox change listeners
            const checkboxes = this.querySelectorAll('.bundle-checkbox');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => this.updateTotal());
            });

            // Add to cart button
            if (this.addToCartButton) {
                this.addToCartButton.addEventListener('click', () => this.addToCart());
            }
        }

        updateTotal() {
            const products = this.querySelectorAll('.product-bundle__item');
            let total = 0;
            let selectedCount = 0;

            products.forEach(product => {
                const checkbox = product.querySelector('.bundle-checkbox');

                // If no checkbox exists (disabled mode) OR checkbox is checked
                const isSelected = !checkbox || checkbox.checked;

                if (!isSelected) return;

                selectedCount += 1;
                const price = parseInt(product.dataset.price) || 0;
                total += price;
            });

            if (this.totalPriceElement) {
                this.totalPriceElement.textContent = theme.Currency.formatPrice(total);
                this.totalPriceElement.dataset.totalPrice = total;
            }

            // Disable button if no products selected
            if (this.addToCartButton) {
                this.addToCartButton.disabled = selectedCount === 0;
            }
        }

        async addToCart() {
            const products = this.querySelectorAll('.product-bundle__item');
            const selectedProducts = [];

            products.forEach(product => {
                const checkbox = product.querySelector('.bundle-checkbox');

                // If no checkbox exists (disabled mode) OR checkbox is checked
                const isSelected = !checkbox || checkbox.checked;

                if (isSelected) {
                    selectedProducts.push(product);
                }
            });

            if (selectedProducts.length === 0) return;

            this.setLoadingState(true);

            try {
                const formData = new FormData();

                // Add items - variant ID always comes from product container
                selectedProducts.forEach((product, index) => {
                    formData.append(`items[${index}][id]`, product.dataset.variantId);
                    formData.append(`items[${index}][quantity]`, '1');
                });

                // Use pub/sub to integrate with theme's cart system
                publish(PUB_SUB_EVENTS.cartAdd, {
                    formData: formData,
                    id: this.id || 'bundle-selector'
                });
            } catch (error) {
                console.error('Error adding to cart:', error);
                this.showErrorFeedback();
            }
        }

        setLoadingState(isLoading) {
            if (isLoading) {
                this.addToCartButton.classList.add('loading');
                this.addToCartButton.setAttribute('aria-disabled', 'true');
                this.querySelector('.loading__spinner').classList.remove('hidden');
            } else {
                this.querySelector('.loading__spinner').classList.add('hidden');
                this.addToCartButton.classList.remove('loading');
                this.addToCartButton.removeAttribute('aria-disabled');
            }
        }

        showSuccessFeedback() {
            const originalText = this.addToCartButton.querySelector('.button__text').textContent;
            this.addToCartButton.querySelector('.button__text').textContent = this.addToCartButton.dataset.successText || 'Added to cart';
            this.setLoadingState(false);

            setTimeout(() => {
                this.addToCartButton.querySelector('.button__text').textContent = originalText;
            }, 2000);
        }

        showErrorFeedback() {
            const originalText = this.addToCartButton.querySelector('.button__text').textContent;
            this.addToCartButton.querySelector('.button__text').textContent = 'Error - Please try again';

            setTimeout(() => {
                this.addToCartButton.querySelector('.button__text').textContent = originalText;
            }, 2000);
        }

        hideSection() {
            this.style.display = 'none';
        }
    }

    customElements.define('product-bundle', ProductBundle);
}